import { mapSharedFolderAssigns, SharedFolderAssign } from "./SharedFolderAssign";
import { mapSharedFolderBy, SharedFolderBy } from "./SharedFolderBy";
import { mapSharedFolderContacts, SharedFolderContact } from "./SharedFolderContact";
import { mapSharedFolderProject, SharedFolderProject } from "./SharedFolderProject";

/* Shared folder */
export interface SharedFolder {
    folder_id?: number;
    project_id?: number;
    folder?: 'Pre Comencencemet' | 'Onsite' | 'General';
    type?: string;
    service_name?: string | null;
    display_name?: string | null;
    folder_type?: string | null;
    add_default_id?: number;
    category?: string | null;
    shared_date?: string | null;
    assign?: SharedFolderAssign[];
    contact?: SharedFolderContact[];
    feature_name?: string;
    feature_key_name?: string;
    shared_by: SharedFolderBy;
    project?: SharedFolderProject;
    file_path: string | null;
}

// to single object maping
export const mapSharedFolder = (data: any): SharedFolder => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: SharedFolder = {
        folder_id: data.folder_id,
        project_id: data.project_id,
        folder: data.folder,
        type: data.type,
        service_name: data.service_name || null,
        display_name: data.display_name || null,
        folder_type: data.folder_type || null,
        add_default_id: data.add_default_id,
        category: data.category,
        shared_date: data.shared_date || null,
        assign: mapSharedFolderAssigns(data.assign),
        contact: mapSharedFolderContacts(data.contact),
        feature_name: data.feature_name,
        feature_key_name: data.feature_key_name,
        shared_by: mapSharedFolderBy(data.shared_by),
        project: mapSharedFolderProject(data.project),
        file_path: data.file_path
    }
    return res;
}

// maping list objects
export const mapSharedFolders = (data: any[]): SharedFolder[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapSharedFolder);
}
